import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Company } from "../domain/company";
import { CompanyService } from "../service/company.service";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";

@Component({
    templateUrl: "./company-table.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class CompanyTableComponent implements OnInit {
    cols: any[];

    companies: Company[];

    selected: Company;

    sortKey: string;

    sortField: string;

    sortOrder: number;

    timeout: any;

    constructor(
        private CompanyService: CompanyService,
        private messageService: MessageService,
        private router: Router
    ) {}

    ngOnInit() {
        this.initializeTableVariables();
        this.getCompanies();
    }

    initializeTableVariables() {
        this.cols = [
            { field: "id", header: "ID" },
            { field: "name", header: "Name" },
        ];
    }

    getCompanies() {
        this.CompanyService.get().then(
            (companies) => (this.companies = companies)
        );
    }

    viewCompany(Company: Company) {
        this.router.navigate(["/companies/", Company.id]);
    }

    deleteCompany(Company: Company) {
        if (
            confirm(
                "Please confirm that you want to delete this company: " +
                    Company.name
            )
        ) {
            this.CompanyService.delete(Company.id.toString()).then(() => {
                this.getCompanies();
            });
        }
    }

    createCompany() {
        let newCompanyName = prompt("New company name");

        if (newCompanyName.trim().length < 1) {
            alert(
                "Company name must contain at least 1 character (not including spaces)."
            );
        } else {
            let newCompany = new Company();
            newCompany.name = newCompanyName;

            this.CompanyService.post(newCompany).then(() => {
                this.getCompanies();
            });
        }
    }

    onSortChange(event) {
        const value = event.value;

        if (value.indexOf("!") === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }
}
